
const footer = {
  state: {
    isShowFooter: true
  },
  mutations: {
    isShowFooter (footer, preload) {
      footer.isShowFooter = preload.isShowFooter;
    }
  },
  actions: {

  }
};

export default footer;



// WEBPACK FOOTER //
// ./src/stores/modules/footer.js